import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewResidue, updateResidue } from '../../../../slices/residue/thunk';
import { setRequireCloseModal } from '../../../../slices/residue/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { getResidueCategoryList, getResidueTypeList } from '../../../../helpers/residue/backend_helper';
import ResidueConversionTab from '../Tabs/ResidueConversionTab';
import { addNewResidueConversion, deleteResidueConversion, updateResidueConversion } from '../../../../slices/thunks';
// import { getResidueTypeList } from '../../../../helpers/residue/backend_helper';

const ResidueForm = ({
	dataResidue,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

    const [selectedResidueCategory, setSelectedResidueCategory] = useState(null);
    const handleResidueCategorySelected = (optionSelected) => {
        setSelectedResidueCategory(optionSelected);
    };
    const [organicCheck, setOrganicCheck] = useState(dataResidue.organic);
    const [disabledCheck, setDisabledCheck] = useState(dataResidue.disable);

	const [dataResidueConversionList, setDataResidueConversionList] = useState([]);
	const [isSavingConversionTab, setIsSavingConversionTab] = useState(false);

	// Estados para campos de valorización
	const [esValorizableCheck, setEsValorizableCheck] = useState(dataResidue.es_valorizable || false);
	const [selectedMoneda, setSelectedMoneda] = useState(dataResidue.moneda || 'CLP');

	const selectorResidue = createSelector(
		state => state.Residues,
		residue => ({
			isAdding: residue.isAdding,
			isAdded: residue.isAdded,
			isUpdating: residue.isUpdating,
			isUpdated: residue.isUpdated,
			isLoadingList: residue.isLoadingList,
			requireCloseModal: residue.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorResidue);

	async function handleSaveDataConversionList(){
		dataResidueConversionList.map(async dataResidueConversion => {
			console.log('iter? ', dataResidueConversion)
			try {
				let response = null;
				if(
					dataResidueConversion?._id &&
					dataResidueConversion.kilogram == 0
				){
					console.log('delete?')
					response = await dispatch(deleteResidueConversion({
						...dataResidueConversion
					})).unwrap();
				}
				if(dataResidueConversion?._id &&
					dataResidueConversion.kilogram != 0){
					console.log('update?')
					response = await dispatch(updateResidueConversion({
						...dataResidueConversion
					})).unwrap();
				}
				if(!dataResidueConversion?._id && dataResidueConversion.kilogram != 0){
					console.log('new?')
					response = await dispatch(addNewResidueConversion({
						...dataResidueConversion
					})).unwrap();
				}
			} catch (err){
				console.error('Error:', err);
			}
			
		})
		
	}

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
            name: dataResidue.name || '',
            code: dataResidue.code || '',
            LER: dataResidue.LER || '',
            volumen: dataResidue.volumen || '',
            es_valorizable: dataResidue.es_valorizable || false,
            valor: dataResidue.valor || '',
            moneda: dataResidue.moneda || 'CLP',
		},
		validationSchema: Yup.object({
            name: Yup.string().required('Campo requerido'),
            code: Yup.string()
			// 	.required('Campo requerido')
			,
            LER: Yup.string()
				// .required('Campo requerido')
			,
            volumen: Yup.number()
                .typeError('debe ser un número entero')
                .required('Campo requerido'),
		}),
		onSubmit: async values => {
			setIsSavingConversionTab(true);
			if (isEdit) {
				const updatedResidue = {
					_id: dataResidue._id,
                    residue_category_id: (selectedResidueCategory?.item?._id ? selectedResidueCategory.item._id : ''),
                    name: values.name,
                    code: String(values.code || ''),
                    LER: String(values.LER || ''),
                    volumen: values.volumen,
                    organic: (organicCheck ? true : false),
                    disabled: (disabledCheck ? true : false),
                    es_valorizable: esValorizableCheck,
                    valor: esValorizableCheck ? parseFloat(values.valor) || null : null,
                    moneda: esValorizableCheck ? values.moneda : null,
				};
				dispatch(updateResidue(updatedResidue));
			} else {
				const newResidue = {
					residue_category_id: (selectedResidueCategory?.item?._id ? selectedResidueCategory.item._id : ''),
                    name: values.name,
                    code: String(values.code || ''),
                    LER: String(values.LER || ''),
                    volumen: values.volumen,
                    organic: (organicCheck ? true : false),
                    disabled: (disabledCheck ? true : false),
                    es_valorizable: esValorizableCheck,
                    valor: esValorizableCheck ? parseFloat(values.valor) || null : null,
                    moneda: esValorizableCheck ? values.moneda : null,
				};
				dispatch(addNewResidue(newResidue));
			}

			await handleSaveDataConversionList();
			setIsSavingConversionTab(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal && !isSavingConversionTab) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal, isSavingConversionTab]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
                            <Col lg={6}>
								<Label for='name' className='form-label'>
									Nombre
								</Label>
								<Input
									name='name'
									id='name'
									className='form-control'
									placeholder='Ingrese un nombre'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.name || ''}
									invalid={
										validation.touched.name &&
										validation.errors.name
											? true
											: false
									}
								/>
								{
                                    validation.touched.name &&
                                    validation.errors.name ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.name}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={6}>
                                <GeneralSelect
                                    label='Categoría de Residuo'
                                    value={{_id: dataResidue.residue_category_id} || ''}
                                    className={''}
                                    // invalid={validation.touched.x && validation.errors.x ? true : false}
                                    // error={validation.errors.x}
                                    onSelect={handleResidueCategorySelected}
                                    requestApi={getResidueCategoryList}
                                    params={{}}
                                    disabled={false}
                                />
                            </Col>
                            <Col lg={4}>
								<Label for='code' className='form-label'>
									Código
								</Label>
								<Input
									name='code'
									id='code'
									className='form-control'
									placeholder='Ingrese un código'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.code || ''}
									invalid={
										validation.touched.code &&
										validation.errors.code
											? true
											: false
									}
								/>
								{
                                    validation.touched.code &&
                                    validation.errors.code ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.code}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={4}>
								<Label for='code' className='form-label'>
									LER
								</Label>
								<Input
									name='LER'
									id='LER'
									className='form-control'
									placeholder='Ingrese un código'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.LER || ''}
									invalid={
										validation.touched.LER &&
										validation.errors.LER
											? true
											: false
									}
								/>
								{
                                    validation.touched.LER &&
                                    validation.errors.LER ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.LER}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={4}>
								<Label for='volumen' className='form-label'>
									Volumen
								</Label>
								<Input
									name='volumen'
									id='volumen'
									className='form-control'
									placeholder='Ingrese un código'
									type='number'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.volumen || ''}
									invalid={
										validation.touched.volumen &&
										validation.errors.volumen
											? true
											: false
									}
								/>
								{
                                    validation.touched.volumen &&
                                    validation.errors.volumen ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.volumen}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <div className='d-flex gap-3 pt-3'>
                                <div>
                                    <FormGroup className='d-flex align-items-center'>
                                        <Label className=''>
                                            <div className='d-flex'>
                                                <Input
                                                    type="checkbox"
                                                    checked={organicCheck}
                                                    onChange={(e) => setOrganicCheck(e.target.checked)}
                                                />
                                                <div className='px-1'>
                                                    ¿Es orgánico?
                                                </div>
                                            </div>
                                        </Label>
                                        {validation.touched.organic &&
                                        validation.errors.organic ? (
                                            <FormFeedback type='invalid'>
                                                {validation.errors.organic}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </div>
                                <div>
                                    {isEdit && (
                                        <FormGroup className='d-flex align-items-center'>
                                            <Label className=''>
                                                <div className='d-flex'>
                                                    <Input
                                                        type="checkbox"
                                                        checked={disabledCheck}
                                                        onChange={(e) => setDisabledCheck(e.target.checked)}
                                                    />
                                                    <div className='px-1'>
                                                        ¿Residuo inactivo?
                                                    </div>
                                                </div>
                                            </Label>
                                            {validation.touched.disabled &&
                                            validation.errors.disabled ? (
                                                <FormFeedback type='invalid'>
                                                    {validation.errors.disabled}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    )}
                                </div>
                            </div>

							{/* Sección de Valorización */}
							<Row className='g-3 pt-4 border-top mt-3'>
								<Col lg={12}>
									<h6 className='text-muted mb-3'>
										<i className='ri-money-dollar-circle-line me-1'></i>
										Configuración de Valorización
									</h6>
								</Col>
								<Col lg={12}>
									<FormGroup className='d-flex align-items-center'>
										<Label className=''>
											<div className='d-flex'>
												<Input
													type="checkbox"
													checked={esValorizableCheck}
													onChange={(e) => {
														setEsValorizableCheck(e.target.checked);
														validation.setFieldValue('es_valorizable', e.target.checked);
													}}
												/>
												<div className='px-1 fw-semibold'>
													¿Es valorizable?
												</div>
											</div>
										</Label>
									</FormGroup>
								</Col>
								{esValorizableCheck && (
									<>
										<Col lg={6}>
											<Label for='valor' className='form-label'>
												Valor
											</Label>
											<Input
												name='valor'
												id='valor'
												className='form-control'
												placeholder='Ingrese el valor por unidad'
												type='number'
												step='0.01'
												min='0'
												onChange={validation.handleChange}
												onBlur={validation.handleBlur}
												value={validation.values.valor || ''}
											/>
										</Col>
										<Col lg={6}>
											<Label for='moneda' className='form-label'>
												Moneda
											</Label>
											<Input
												type="select"
												name="moneda"
												id="moneda"
												className='form-control'
												onChange={(e) => {
													setSelectedMoneda(e.target.value);
													validation.setFieldValue('moneda', e.target.value);
												}}
												onBlur={validation.handleBlur}
												value={selectedMoneda}
											>
												<option value="CLP">CLP - Peso Chileno</option>
												<option value="USD">USD - Dólar Americano</option>
												<option value="EUR">EUR - Euro</option>
												<option value="UF">UF - Unidad de Fomento</option>
											</Input>
										</Col>
									</>
								)}
							</Row>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<ResidueConversionTab
							dataResidue={dataResidue}
							dataResidueConversionList={dataResidueConversionList}
                    		handleDataResidueConversionList={setDataResidueConversionList}
						/>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="ri-close-line label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Residuo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default ResidueForm;
